import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to register with both query param and location state as fallback
    // This allows the from path to be preserved even if state is lost
    const registerPath = `/register?from=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={registerPath} state={{ from: location }} replace />;
  }

  return children;
}